/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useApi } from '../services';

export const useGetAccessGroupById = (idGroup) => useApi(`v2/admin/${idGroup}/access-group`, 'GET', {}, {}, true);

export const useGetAccessGroups = () => useApi(`v2/access-group`, 'POST', {}, {}, true);

export const useAccessGroupClone = (idGroup) => useApi(`v2/access-group/${idGroup}/clone`, 'POST', {}, {});

export const useAccessGroupExpire  = (idGroup) => useApi(`v2/access-group/${idGroup}/expire`, 'DELETE', {}, {});

export const useAccessGroupRestore  = (idGroup) => useApi(`v2/access-group/${idGroup}/restore`, 'PATCH', {}, {});
